import {persistStore,persistReducer} from "redux-persist";
import storage from 'redux-persist/lib/storage';
import { compose, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { rootReducer } from "./store";
import { apiMiddleware } from "./store/orgs/middleware";

const persistConfig = {
    key : 'primary',
    storage,
    blacklist: ['iframe', 'form', 'product', 'forms', 'contextMenu', 'tars', 'onboarding', "widgetId"] // navigation will not be persisted
}

const persistedReducer = persistReducer(persistConfig,rootReducer);

const store = createStore(
    persistedReducer,
    undefined,
    compose(applyMiddleware(thunk, apiMiddleware))
);

const persistor = persistStore(store);

export {
    store,
    persistor
}
